import { useState, useCallback } from "react";
import axios from "axios";

export function useKycLink({ user, accessToken, url }) {
  const [kycLink, setKycLink] = useState(null);

  const fetchKycLink = useCallback(async () => {
    const apiKey = "b50eb96202f539479e288ab6547ea9484003";
    const formId = "8a53986012e6114ab709816170bac18316e0";

    try {
      if (!user?.use_id) throw new Error("Usuario no válido");

      // Actualizar el campo use_verif del usuario
      await axios.put(
        `${url}/users/${user.use_id}`,
        { use_verif: "E" },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Verificar si ya existe un kyc_link
      const existingKycLinkResponse = await axios.get(
        `${url}/kyclink/user/${user.use_id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const existingKycLink = existingKycLinkResponse.data;

      if (existingKycLink && existingKycLink.kyc_link) {
        window.open(existingKycLink.kyc_link, "_blank");
        setKycLink(existingKycLink.kyc_link);
      } else {
        // Si no existe un link, obtener uno nuevo
        const response = await fetch(
          `https://kyc-api.amlbot.com/forms/${formId}/urls`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + apiKey,
            },
          }
        );

        const data = await response.json();

        if (data && data.form_url) {
          const kycData = {
            kyc_link_status: "Pending",
            kyc_link_date: new Date().toISOString(),
            kyc_User_id: user.use_id,
            form_id: data.form_id,
            form_url: data.form_url,
            verification_id: data.verification_id,
            form_token: data.form_token,
            verification_attempts_left: data.verification_attempts_left,
          };

          await axios.post(`${url}/kyclink/create`, kycData, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          });

          window.open(data.form_url, "_blank");
          setKycLink(data.form_url);
        }
      }
    } catch (error) {
      setKycLink("Error al conectar con la API");
    }
  }, [user, accessToken, url]);

  return { kycLink, fetchKycLink };
}